import { createContext, useContext, type ReactNode } from 'react';

export type WorkspaceMobileLayer = 'menu' | 'context' | 'intelligence' | 'account';

export interface WorkspaceChromeHosts {
  activeMobileLayer: WorkspaceMobileLayer | null;
  closeMobileLayer(layer: WorkspaceMobileLayer): void;
  desktopContext: HTMLElement | null;
  headerIntelligence?: HTMLElement | null;
  registerAsk?(scope: string, open: (prompt: string) => void): () => void;
  requestAsk?(prompt: string, scope: string): boolean;
  registerSettings?(open: () => void): () => void;
  requestSettings?(): boolean;
  mobileContext: HTMLElement | null;
  mobileIntelligence: HTMLElement | null;
  mobileMenu: HTMLElement | null;
  openMobileLayer(layer: WorkspaceMobileLayer): void;
}

const WorkspaceChromeHost = createContext<WorkspaceChromeHosts | undefined>(undefined);

export function WorkspaceChromeHostProvider({ children, hosts }: {
  children: ReactNode;
  hosts: WorkspaceChromeHosts;
}) {
  return <WorkspaceChromeHost.Provider value={hosts}>{children}</WorkspaceChromeHost.Provider>;
}

export function useWorkspaceChromeHosts(): WorkspaceChromeHosts | undefined {
  return useContext(WorkspaceChromeHost);
}
